import { render, staticRenderFns } from "./havePermission.vue?vue&type=template&id=5b660692"
import script from "./havePermission.vue?vue&type=script&lang=js"
export * from "./havePermission.vue?vue&type=script&lang=js"
import style0 from "./havePermission.vue?vue&type=style&index=0&id=5b660692&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports